<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Invoices
                        <span v-if="is_loading || fetching_data" class="button is-white has-text-right preloader"
                              :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>

            <!-- search -->
            <div class="columns is-paddingless is-marginless" v-if="!is_loading">
                <div class="columns is-vcentered">
                    <div class="column is-desktop is-12-mobile is-full-tablet is-paddingless margin-top-4 is-full-widescreen">
                        <span class="is-size-7 has-text-grey is-full-mobile">Business name or reference: &nbsp;</span>
                    </div>
                </div>

                <div class="column is-paddingless is-marginless is-9-tablet is-9-desktop">
                    <search v-on:search="search($event)"
                            v-on:keywordChanged="keywordChanged($event)"
                            placeholder="Search"
                            :addMarginLeft=false
                            class="is-paddingless is-marginless"></search>
                </div>
            </div>

            <div class="columns is-paddingless is-marginless" v-if="!is_loading">
                <!--status dropdown -->
                <div class="column margin-top-20 padding-left-0 padding-right-0">
                    <div class="columns is-vcentered is-paddingless is-marginless">
                        <div class="column is-narrow is-paddingless is-marginless">
                            <span class="is-size-7 has-text-grey is-pulled-left">Date: &nbsp;</span>
                        </div>
                        <div class="column is-paddingless is-marginless is-10">
                            <input
                                    type="text"
                                    id="datepicker-trigger"
                                    class="airbnb-datepicker-trigger padding-right-0"
                                    placeholder="Select dates"
                                    ref="airbnb_datepicker"
                                    :value="formatDates(invoice_date_from, invoice_date_to)"
                            >

                            <AirbnbStyleDatepicker
                                    :trigger-element-id="'datepicker-trigger'"
                                    :showShortcutsMenuTrigger="false"
                                    :mode="'range'"
                                    :fullscreen-mobile="true"
                                    :date-one="invoice_date_from"
                                    :date-two="invoice_date_to"
                                    :fullscreenMobile="true"
                                    @date-one-selected="val => { invoice_date_from = val }"
                                    @date-two-selected="val => { invoice_date_to = val }"
                            >
                                <template slot="close-icon">
                                    <i class="far fa-times-circle"></i>
                                </template>
                            </AirbnbStyleDatepicker>
                        </div>
                    </div>
                </div>

                <!--status dropdown -->
                <div class="column margin-top-20 is-3-desktop padding-left-0">
                    <div class="columns is-vcentered is-paddingless is-marginless">
                        <div class="column is-narrow is-paddingless is-marginless">
                            <span class="is-size-7 has-text-grey is-pulled-left">Status: &nbsp;</span>
                        </div>
                        <div class="column is-paddingless is-marginless">
                            <dropdown dropdownName="invoice_status" ref="invoice_status" placeHolder=""
                                      :items="statuses" btnMinWidth=""
                                      class="is-fullwidth"
                                      v-on:changed="setInvoiceStatus($event)"></dropdown>
                        </div>
                    </div>
                </div>

                <!--invoice type dropdown -->
                <div class="column margin-top-20 is-3-desktop padding-left-0 padding-right-0">
                    <div class="columns is-vcentered is-paddingless is-marginless">
                        <div class="column is-narrow is-paddingless is-marginless">
                            <span class="is-size-7 has-text-grey is-pulled-left">Invoice type: &nbsp;</span>
                        </div>
                        <div class="column is-paddingless is-marginless">
                            <dropdown dropdownName="invoice_type" ref="invoice_type" placeHolder=""
                                      :items.sync="invoice_types" btnMinWidth=""
                                      class="is-fullwidth"
                                      v-on:changed="setInvoiceType($event)"></dropdown>
                        </div>
                    </div>
                </div>

                <div class="column margin-top-20 is-3-desktop padding-right-0">
                    <div class="columns is-vcentered is-paddingless is-marginless">
                        <button class="button is-button-grey-outline is-button-small margin-right-10"
                                type="reset" @click.prevent="resetFilter">RESET
                        </button>
                        <button type="submit"
                                class="button is-button-grey is-button-small"
                                @click.prevent="applyFilter">APPLY
                        </button>
                    </div>
                </div>

            </div>

            <div class="columns" v-if="!is_loading">
                <div class="column padding-left-0 padding-bottom-0">
                    <div class="has-text-left">
                        <h3 class="strong-results" v-html="search_message"></h3>
                    </div>
                </div>
            </div>

            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr>
                        <td class="is-hidden-mobile pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">
                            Date
                        </td>
                        <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">
                            Business
                        </td>
                        <td class="is-narrow-mobile pad90-desktop is-size-7-desktop has-text-weight-bold has-text-grey">
                            Reference
                        </td>
                        <td class="is-narrow-mobile pad90-desktop is-size-7-desktop has-text-weight-bold has-text-grey">
                          PO Number
                        </td>
                        <td class="is-narrow-mobile is-size-7-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">
                            Type
                        </td>
                        <td class="is-hidden-mobile is-narrow-mobile is-size-7-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">
                            Status
                        </td>
                        <td class="is-hidden-mobile is-narrow-mobile is-size-7-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">
                            Amount (exc VAT)
                        </td>
                        <td class="is-hidden-mobile is-narrow-mobile is-size-7-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">
                            Amount paid
                        </td>
                        <td class="is-size-7-mobile is-narrow-mobile"></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                        <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey"
                            colspan="7">
                            <p class="has-text-centered is-padded-20">No results found</p>
                        </td>
                    </tr>
                    <tr class="margin-bottom-20" v-if="items.length > 0" v-for="(invoice, index) in items">
                        <td class="is-hidden-mobile is-size-7-mobile is-size-7-touch">{{invoice.created_at}}
                        </td>
                        <td v-if="invoice.org_name"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            <a target="__blank" :href="`${app_url}/business/${invoice.org_slug}/billing`"
                               class="is-hidden-mobile has-text-underlined color-2aabe1">{{invoice.org_name}}</a>
                        </td>
                        <td v-else-if="invoice.onboard_name"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch has-text-weight-bold">
                            {{invoice.onboard_name}}
                        </td>
                        <td v-if="invoice.tax_number && invoice.payment_reference"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.tax_number}}
                        </td>
                        <td v-else-if="!invoice.tax_number && invoice.payment_reference"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.payment_reference}}
                        </td>
                        <td v-if="invoice.po_number" class="is-hidden-mobile is-size-7-mobile is-size-7-touch">
                          {{invoice.po_number}}
                        </td>
                        <td v-else class="is-hidden-mobile is-size-7-mobile is-size-7-touch">
                          <a href="javascript:void(0);" @click.prevent="openAddModal(invoice.id)">Add now</a>
                        </td>
                        <td v-if="invoice.tax_number && invoice.payment_reference"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            Tax
                        </td>
                        <td v-else-if="!invoice.tax_number && invoice.payment_reference"
                            class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            Pro forma &nbsp;
                            <button @click.prevent="confirmConversion(invoice, index)"
                                    class="button-mobile-table is-button-grey circle-border circle-border-edit">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                        </td>
                        <td class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.payment_status}}
                        </td>
                        <td class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.total_exc_vat}}
                        </td>
                        <td v-if="(invoice.tax_number && invoice.payment_reference && invoice.payment_status === 'PAID')"
                            class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.total_inc_vat}}
                        </td>
                        <td v-else-if="(!invoice.tax_number && invoice.payment_reference) || (invoice.tax_number && invoice.payment_status === 'PENDING')"
                            class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">
                        </td>
                        <td v-else-if="(invoice.tax_number && invoice.payment_reference && invoice.payment_status === 'CANCELLED')"
                            class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">
                            {{invoice.total_inc_vat}}
                        </td>
                        <td class="is-size-7-mobile">
                            <a :href="`${api_url}/invoices/${invoice.id}/file`"
                               class="is-hidden-mobile has-text-underlined"><img src="/static/img/invoice-download.png" /></a>
                            <a :href="`${api_url}/invoices/${invoice.id}/file`"
                               class="button-mobile-table is-button-blue circle-border is-hidden-desktop is-hidden-tablet is-hidden-widescreen">
                                <i class="fas fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <paginator :dataSet="dataSet" @changed="getAllInvoices" :keyword_string="keyword_string"></paginator>
            </div>
          <div class="modal is-active po-number-modal" v-if="showPopup">
            <div class="modal-background"></div>
            <div class="modal-card">
              <div class="modal-content">
                <header class="modal-card-head headnewcl">
                  <strong>Add PO Number</strong>
                </header>
                <section class="modal-card-body">
                  <div class="notify-check-section">
                    <p class='error'><span v-if="this.errorMessage">{{this.errorMessage}}</span></p>
                      <input
                        type="text"
                        name="po_number"
                        v-model="po_number_value"
                        v-on:keyup="keyvalidation"
                        max="30"
                      />
                  </div>
                </section>
                <footer class="modal-card-foot delete-review-footer">
                  <button class="button" @click="showPopup=false">CANCEL</button>
                  <button class="button save" @click.prevent="addPONumber(invoiceId)" :disabled="validated == false">Save</button>
                </footer>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import Dropdown from './../../components/DropDown.vue'
  import misc from '../../mixins/misc.js'
  import Search from './../../components/Search.vue'
  import qs from 'qs'
  import format from 'date-fns/format'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Invoices'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Invoices'
      })
    },
    components: {Paginator, Search, Dropdown},
    mixins: [misc],
    data () {
      return {
        dateFormat: 'DD-MM-YYYY',
        api_url: process.env.API_URL,
        app_url: process.env.APP_URL,
        statuses: [
          {
            name: 'Paid',
            value: 'PAID'
          },
          {
            name: 'Pending',
            value: 'PENDING'
          }, {
            name: 'Cancelled',
            value: 'CANCELLED'
          },
          {
            name: 'Expired',
            value: 'EXPIRED'
          }
        ],
        invoice_types: [
          {
            name: 'Pro forma',
            value: 'PROFORMA'
          },
          {
            name: 'Tax',
            value: 'TAX'
          }
        ],
        dates_set: false,
        invoice_date_from: '',
        invoice_date_to: '',
        invoice_date_search: '',
        date_picker_placeholder: '',
        date_picker_editable: false,
        date_picker_shortcuts: false,
        fetching_data: false,
        search_message: undefined,
        keyword_search: undefined,
        keyword_string: undefined,
        filter_search: undefined,
        payment_status: undefined,
        payment_status_search: '',
        invoice_type: undefined,
        invoice_type_search: '',
        is_loading: true,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        invoiceId: 0,
        showPopup: false,
        po_number_value: '',
        validated: false,
        errorMessage: ''
      }
    },
    created () {
      this.getAllInvoices(null)

      // listen for the convertInvoice event emitted by the Modal component on behalf of the global event hub
      window.events.$on('convertInvoice', this.convertInvoice)
    },
    methods: {
      /**
       * Sets invoice date to filter by
       * @param {dateFrom} dateFrom date from range
       * @param {dateTo} dateTo date to range
       * @returns {object}
       */
      formatDates (dateFrom, dateTo) {
        let formattedDates = ''
        if (dateFrom) {
          formattedDates = format(dateFrom, this.dateFormat)
        }
        if (dateTo) {
          formattedDates += ' - ' + format(dateTo, this.dateFormat)
        }

        if (this.invoice_date_from || this.invoice_date_to) {
          this.dates_set = true
        }

        if (!this.invoice_date_from && !this.invoice_date_to) {
          this.dates_set = false
        }
        this.invoice_date_search = qs.stringify({invoice_date_from: this.invoice_date_from, invoice_date_to: this.invoice_date_to})

        return formattedDates
      },
      /**
       * Search keyword/term changed since clicking submit. Update is needed so filters can pick
       * up most up to date keyword term to use for filtering.
       * @param {keyword} keyword keyword
       * @returns {void}
       */
      keywordChanged (keyword) {
        this.keyword_search = qs.stringify({keyword: keyword})
        this.keyword_string = keyword
      },
      /**
       * Sets invoice status to filter by
       * @param {string} event invoice status
       * @returns {void}
       */
      setInvoiceStatus (event) {
        this.payment_status = event.value
        this.payment_status_search = qs.stringify({payment_status: event.value})
      },
      /**
       * Sets invoice type to filter by
       * @param {string} event invoice type
       * @returns {void}
       */
      setInvoiceType (event) {
        this.invoice_type = event.value
        this.invoice_type_search = qs.stringify({invoice_type: event.value})
      },
      /**
       * Resets radio buttons in instances of dropdown components and all variables needing resetting.
       * @returns {void}
       */
      resetFilter () {
        this.$refs.invoice_type.$refs.dropdown.innerHTML = ''
        this.$refs.invoice_status.$refs.dropdown.innerHTML = ''

        // uncheck invoice status radio buttons
        this.statuses.forEach((item) => {
          this.$refs.invoice_status.$refs[item.value][0].checked = false
        })

        // uncheck invoice type radio buttons
        this.invoice_types.forEach((item) => {
          this.$refs.invoice_type.$refs[item.value][0].checked = false
        })

        this.payment_status = ''
        this.payment_status_search = ''
        this.invoice_type_search = ''
        this.invoice_type = ''
        this.invoice_date_search = ''
        this.invoice_date = ''
        this.invoice_date_from = ''
        this.invoice_date_to = ''
        this.$refs.airbnb_datepicker.value = ''
        this.getAllInvoices(1)
      },
      /**
       * Proxy function in calling api search on user's filtering options.
       * @returns {void}
       */
      applyFilter () {
        this.getAllInvoices(1)
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getAllInvoices(1)
      },
      /**
       * Fires off modal in confirming conversion cta.
       * @param {object} invoice pro forma invoice to convert.
       * @param {index} index index from invoice in items tray
       * @returns {void}
       */
      confirmConversion (invoice, index) {
        // initialize event producer's props
        let producer = invoice
        producer.index = index

        // initialize modal's props
        this.modal_props = {
          'title': '',
          'body': `Update invoice with reference number <strong>${invoice.payment_reference}</strong> from pro forma to tax invoice?`,
          'btn_action_title': 'YES, UPDATE',
          'show_btns': true,
          'task': 'convertInvoice',
          'producer': producer
        }
        // fire off confirmation modal
        modal(this.modal_props)
      },
      /**
       * Makes a call to api to manually match a payment to an invoice.
       * @param {object} producer record
       * @returns {void}
       */
      async convertInvoice (producer) {
        try {
          let payload = {invoice_uuid: producer.producer.id}
          let response = await axios.post(`/invoices/convert-proforma-invoice`, payload)
          let data = response.data
          this.items[producer.producer.index].tax_number = data.tax_number
          this.items[producer.producer.index].payment_status = data.payment_status
        } catch (error) {
          flash('An unexpected error occurred. Please try again later', 'is-danger')
        }
      },
      /**
       * Make request to api to get all invoices.
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getAllInvoices (page) {
        this.page = page
        this.fetching_data = true
        axios.get(this.url(page))
            .then((response) => {
              this.refresh(response, 'invoices')
              this.is_loading = false
              this.fetching_data = false
            })
            .catch((error) => {
              flash('You are not authorized to view this resource.', 'is-danger')
              console.log(error)
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @return {string}
       */
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)
          page = query ? query[1] : 1
        }

        if (this.keyword_search !== undefined && this.keyword_string !== 0) {
          page += `&${this.keyword_search}`
        }

        if (this.dates_set) {
          page += `&${this.invoice_date_search}`
        }

        if (this.invoice_type !== undefined) {
          page += `&${this.invoice_type_search}`
        }

        if (this.payment_status !== undefined) {
          page += `&${this.payment_status_search}`
        }
        return `/invoices?page=${page}`
      },
      /**
       * po number length validation
       * @returns {void}
       */
      keyvalidation () {
        if (this.po_number_value.length > 0) {
          this.validated = true
        } else {
          this.validated = false
        }
      },
      /**
       * open po number form in modal box
       * @param {string} invoiceId invoice id
       * @returns {void}
       */
      openAddModal (invoiceId) {
        this.validated = false
        this.po_number_value = ''
        this.invoiceId = invoiceId
        this.showPopup = true
        this.errorMessage = ''
      },
      /**
       * add po number to an invoice
       * @param {string} invoiceId invoice id
       * @returns {void}
       */
      async addPONumber (invoiceId) {
        try {
          let podata = { invoiceId: invoiceId, po_number: this.po_number_value }
          await axios.post(`/invoices/add-po-number`, podata)
          this.getAllInvoices(null)
          this.showPopup = false
        } catch (error) {
          if (error.response.status === 401) {
            this.errorMessage = 'You are not authorized to perform this action'
          } else if (error.response.status === 422) {
            if (this.po_number_value === '') {
              this.errorMessage = 'PO Number should not be empty'
            } else {
              this.errorMessage = 'PO Number length should not be more than 30'
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }
    .color-58595b {
        color: #58595b;
    }
    .input {
        font-size: 10pt;
    }
   .headnewcl{
      border-bottom: 0px;
      background: #fff;
    }
    .modal-card-foot{
      border-top: 0px;
      background: #fff;
    }
    .modal-content{
      width: 400px;
      border: 2px;
      border-color: #000;
      border-style: solid;
      text-align: center;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[name='po_number']{
      width: 225px;
      -moz-appearance:textfield;
    }
    .modal-card-head strong {
      padding-left: 106px;
      color: #000;
    }
  .modal-card-foot button{
    margin-left: 72px;
    width: 90px;
    border-color: #000;
  }
   .modal-card-foot .button(:last-child) {
      margin-right: 0px;
    }
  .save{
    margin-left: 36px !important;
  }
  .error span{
    color: red;
    font-size: 12px;
  }
  .modal-card-head, .modal-card-foot{
    padding: 15px;
  }
  .strong-results label{
    font-weight: 300 !important;
    font-size: 15px !important;
  }
  .download-icon{
    background-image: url(/static/img/invoice-download.png);
    background-repeat: no-repeat;
  }
  @media all and (min-width:0px) and (max-width: 460px) {
    .modal-content{
      width:250px;
    }
    .modal-card-head strong{
      padding-left: 50px;
    }
    .modal-card-foot button{
      margin-left: 9px;
    }
    input[name='po_number']{
      width: 200px;
    }
    .modal-card-body{
      padding: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/Invoices.vue